import { render } from "./PriceDecreaseListView.vue?vue&type=template&id=045ed6ea&scoped=true"
import script from "./PriceDecreaseListView.vue?vue&type=script&lang=js"
export * from "./PriceDecreaseListView.vue?vue&type=script&lang=js"

import "./PriceDecreaseListView.vue?vue&type=style&index=0&id=045ed6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045ed6ea"]])

export default __exports__